import GettingStarted from "../components/main/getting-started";
import MainBlock from "../components/main/main-screen";
import ModelReview from "../components/main/model-review";
import ShortMain from "../components/main/short-main";
import CardsAbout from "../components/main/cards-about";
import FormBlock from "../components/main/form";
import GetPDF from "../components/main/get-pdf";
import Cases from "../components/main/cases";
import Questions from "../components/main/popular-questions";

function Main() {
    return ( 
        <>
            <MainBlock />
            <GetPDF lang="d"/>
            <ShortMain />
            <CardsAbout />
            <ModelReview />
            <Cases />
            <GettingStarted />
            <FormBlock />
            <Questions />
        </>
     );
}

export default Main;